import space from './space';
/* eslint-disable sort-keys-fix/sort-keys-fix */
const borderRadius = {
    radii: Object.assign(Object.assign({}, space), { none: '0', sm: '0.125em', base: '0.25em', md: '0.375em', lg: '0.5em', xl: '0.75em', '2xl': '1em', '3xl': '1.5em', full: '9999px' }),
};
export default borderRadius;
